// solves the security vulnerability opening content in a new tab
// https://mathiasbynens.github.io/rel-noopener/
export function windowOpener (url) {
  const otherWindow = window.open();
  if (otherWindow) {
    otherWindow.opener = null;
    otherWindow.location = url;
  }
}
